import PriceBar from './PriceBarDesktop';
export default PriceBar;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/PriceBar/PriceBarSub/PriceBarDesktop/index.js
// module id = 2231
// module chunks = 8